// "Delete Purchase Request" confirmation for the Purchase panel. Hard-deletes
// the request (the backend only allows it while pending / pending approval /
// cancelled, and only for the requester or an admin).
import React, { useState } from 'react';
import { X, Trash2 } from 'lucide-react';
import { deletePurchaseRequest } from '../../../api';
import showToast from '../../../utils/toast';
import './AddPurchaseRequestModal.css';
import './DeletePurchaseRequestModal.css';

export default function DeletePurchaseRequestModal({ request, itemsLabel, onClose, onDeleted = () => {} }) {
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        try {
            setDeleting(true);
            const response = await deletePurchaseRequest(request._id);
            if (response.success) {
                showToast('Purchase request deleted successfully', 'success');
                onDeleted();
            } else {
                showToast(response.message || 'Failed to delete purchase request', 'error');
            }
        } catch (error) {
            showToast(error.response?.data?.message || 'Failed to delete purchase request', 'error');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div className="apr-overlay" onClick={deleting ? undefined : onClose}>
            <div className="apr-modal dpr-modal" role="alertdialog" aria-labelledby="dpr-title" onClick={(e) => e.stopPropagation()}>
                <div className="apr-header">
                    <h3 id="dpr-title">Delete Purchase Request</h3>
                    <button type="button" className="apr-close" onClick={onClose} disabled={deleting} aria-label="Close">
                        <X size={18} />
                    </button>
                </div>

                <div className="apr-body dpr-body">
                    <div className="dpr-icon"><Trash2 size={22} /></div>
                    <p>Are you sure you want to permanently delete this purchase request? This action cannot be undone.</p>
                    <div className="dpr-summary">
                        <strong>{itemsLabel}</strong>
                        {request.requestId && <span>{request.requestId}</span>}
                    </div>
                </div>

                <div className="apr-footer">
                    <button type="button" className="apr-btn-cancel" onClick={onClose} disabled={deleting}>
                        Cancel
                    </button>
                    <button type="button" className="dpr-btn-delete" onClick={handleDelete} disabled={deleting}>
                        {deleting ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}
